import { call, put, takeLatest } from 'redux-saga/effects';
import { ApiResponse } from '../../api/request';
import {
  allEventListAPI
} from '../../api/provider/booking/booking-provider';
import { productListAPI, smartObjectAPI } from '../../api/provider/product/product-provider';
import { authenticatedCall } from '../../utils/authenticated-call';
import {
  getEventsListAction, getEventsListErrorAction,
  getEventsListSuccessAction
} from '../../store/shared/events-list.store';

function* eventsListSaga(data: any) {

  try {
    const eventsListResponse: ApiResponse = yield authenticatedCall(allEventListAPI, data.payload);
    const roomsListResponse: ApiResponse = yield call(productListAPI)
    const smartObjectResponse: ApiResponse  = yield authenticatedCall(smartObjectAPI);

    const response = {
      events: eventsListResponse.data.data,
      rooms: roomsListResponse.data.data,
      smartObjects: smartObjectResponse.data.data
    }

    yield put(getEventsListSuccessAction(response));

  } catch (error: any) {
    yield put(getEventsListErrorAction(error.localizedMessage))
    return
  }

}

export function* eventsListSagas() {
  yield takeLatest(getEventsListAction.type, eventsListSaga);
}
